import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import {
  Grid,
  IconButton,
  Tooltip,
  Button,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import mgmtVariantOptions from "src/services/mgmtVariantOptions";
import { useNavigate } from "react-router-dom";

function Result({ variantOptions }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState(variantOptions);
  useEffect(() => {
  setRows(variantOptions);
}, [variantOptions]);
  const handleDelete = async (customerId, variationId) => {
  try {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this variant option?"
    );

    if (!confirmDelete) {
      return;
    }

    await mgmtVariantOptions.deleteVariantOption(
      customerId,
      variationId
    );
    setRows((prevRows) =>
  prevRows.filter(
    (row) =>
      !(
        row.customerId === customerId &&
        row.variationId === variationId
      )
  )
);

  } catch (error) {
  }
};

  const columns = [
    {
      field: "customerId",
      headerName: "Customer ID",
      width: 120,
    },
    {
      field: "variationId",
      headerName: "Variation ID",
      width: 120,
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
    },
    {
      field: "values",
      headerName: "Values",
      width: 350,
      valueGetter: (params) =>
        Array.isArray(params.row.values)
          ? params.row.values.join(", ")
          : "",
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {/* Edit */}
          <Tooltip title="Edit">
            <IconButton
              onClick={() => {
                navigate(
                  "/app/management/variant-options/edit",
                  {
                    state: params.row,
                  }
                );
              }}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>

          {/* Delete */}
 <Tooltip title="Delete">
  <IconButton
    color="error"
    onClick={() =>
      handleDelete(
        params.row.customerId,
        params.row.variationId
      )
    }
  >
    <DeleteIcon />
  </IconButton>
</Tooltip>
        </>
      ),
    },
  ];

return (
  <Grid
    container
    sx={{
      width: "90%",
      margin: "15px auto",
      display: "block",
    }}
  >
    {/* Add Variant Option Button */}
    <Grid
      container
      sx={{
        width: "100%",
        mb: 1,
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={() =>
          navigate("/app/management/variant-options/create")
        }
      >
        ADD VARIANT OPTION
      </Button>
    </Grid>

    {/* Variant Options Table */}
    <Grid
      sx={{
        height: 500,
        width: "100%",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) =>
          `${row.customerId}-${row.variationId}`
        }
        pageSize={10}
        rowsPerPageOptions={[10]}
      />
    </Grid>
  </Grid>
);
}

Result.propTypes = {
  variantOptions: PropTypes.array,
};

Result.defaultProps = {
  variantOptions: [],
};

export default Result;